import {useEffect, useState} from "react";
import store from "@/store";
import {LocalStorageKey, LocalStorageManagement} from "@/libs/LocalStorage";
import {useDispatch} from "react-redux";
import {ActInitUserToken} from "@/store/action/user";

export function useIsMobile() {
    const [isShowMobile, setIsShowMobile] = useState(false);

    useEffect(() => {
        setIsShowMobile(window.matchMedia('(max-width: 599px)').matches);
        document.body.onresize = (e) => {
            setIsShowMobile(window.matchMedia('(max-width: 599px)').matches)
        }
        return () => {
            document.body.onresize = null;
        }
    }, []);

    return {isShowMobile};
}


export function useStateControls() {
    const [state, setState] = useState<ReturnType<typeof store.getState>>();

    useEffect(() => {
        setState(store.getState())
        const s = store.subscribe(() => {
            setState(store.getState())
        });
        return () => {
            s();
        }
    }, []);

    return {...state?.controls} as ReturnType<typeof store.getState>['controls'];
}

export function useStateUserInfo() {
    const [state, setState] = useState<ReturnType<typeof store.getState>>();
    const dispatch = useDispatch();

    useEffect(() => {
        const token = new LocalStorageManagement(LocalStorageKey.token).get();
        if (token) {
            dispatch(ActInitUserToken(token))
        }

        setState(store.getState())
        const s = store.subscribe(() => {
            setState(store.getState());
        });
        return () => {
            s();
        }
    }, []);

    return {...state?.user} as ReturnType<typeof store.getState>['user'];
}
